import {BaseSpringServiceCB} from '@aiknow-srl/aik-ngx-http';
import {UserOPEEnum} from "./UserOPEEnum";

/**
 * I inner class
 */
class I {
  public language!: string;
}

/**
 * O inner class
 */

class O {
}


/**
 * put reseller class
 */

export class SetUserLanguageCB extends BaseSpringServiceCB {

  /**
   * I
   */
  public i: I;


  /**   * O
   */
  public o: O;


  /**
   * constructor
   */
  constructor() {
    super(UserOPEEnum.SetUserLanguage);
    this.i = new I();
    this.o = new O();
  }

}
